/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import useSize from 'plugin/virtual-braindate/component/hook/useSize';
import styles from './Fixed.style';
import classNames from 'classnames';
const useStyles = createUseThemeStyles(styles);

type Props = {
  children: React.Node,
  zIndex?: number,
  fullWidth?: boolean,
  layoutClass?: string,
  rootEltTestId?: string,
  show?: boolean,
};

const Fixed = ({
  children,
  zIndex = 1,
  fullWidth,
  layoutClass,
  rootEltTestId,
  show = true,
}: Props): React.Node => {
  const rootRef = React.useRef<HTMLElement | null>(null);
  const wrapperRef = React.useRef<HTMLElement | null>(null);

  const rootSize = useSize(rootRef);
  const wrapperSize = useSize(wrapperRef);

  const classes = useStyles();

  return (
    <div
      ref={wrapperRef}
      className={classNames(classes.root, layoutClass)}
      style={{
        height: rootSize ? rootSize.height : 'auto',
        position: 'relative',
        width: fullWidth ? '100%' : rootSize ? rootSize.width : 'auto',
        display: show === true ? 'block' : 'none',
      }}
    >
      <div
        id={rootEltTestId}
        ref={rootRef}
        className={classes.wrapper}
        style={{
          width: fullWidth && wrapperSize ? wrapperSize.width : 'auto',
          minWidth: fullWidth && wrapperSize ? wrapperSize.width : 'auto',
          position: wrapperSize ? 'fixed' : 'relative',
          zIndex,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default React.memo<Props>(Fixed);
